import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Auth from "./features/Auth/Auth";
import Main from "./features/Main/Main";
import EventManagements from "./features/EventManagements/EventManagements";

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: 0,
    },
  },
});

function App() {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#389e0d" } }}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="bang-dieu-khien" />} />
            <Route path="xac-thuc/*" element={<Auth />} />
            <Route path="bang-dieu-khien/*" element={<Main />} />
            <Route
              path="quan-ly-su-kien/:id/*"
              element={<EventManagements />}
            />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ConfigProvider>
  );
}

export default App;
